import { Dayjs } from 'dayjs'
import dayjs from 'utils/dayjs'
import i18n from 'utils/i18n'

const customFormats = {
  default: {
    withYear: 'LLLL',
    withoutYear: 'ddd, DD MMM [at] h:mm a',
    withGMT: 'LLLL ([GMT] Z)',
    withoutTime: 'ddd, DD MMM YYYY',
    noticeDate: 'MMMM DD, YYYY'
  },
  'ko-kr': {
    withYear: 'YYYY년 M월 D일 dddd a h:mm',
    withoutYear: 'M월 D일 dddd a h:mm',
    withGMT: 'YYYY년 M월 D일 dddd a h:mm ([GMT] Z)',
    withoutTime: 'YYYY년 M월 D일',
    noticeDate: 'MMMM D일, YYYY년'
  },
  'en-gb': {
    withYear: 'ddd, DD MMM YYYY [at] h:mm a',
    withoutYear: 'ddd, DD MMM [at] h:mm a',
    withGMT: 'ddd, DD MMM YYYY [at] h:mm a ([GMT] Z)',
    withoutTime: 'ddd, DD MMM YYYY',
    noticeDate: 'MMMM DD, YYYY'
  },
  'en-us': {
    withYear: 'ddd, MMM DD, YYYY [at] h:mm A',
    withoutYear: 'ddd, MMM DD, [at] h:mm A',
    withGMT: 'ddd, MMM DD, YYYY [at] h:mm A ([GMT] Z)',
    withoutTime: 'ddd, MMM DD, YYYY',
    noticeDate: 'MMMM DD, YYYY'
  }
}

export function useDateTime() {
  return (
    date: number | string,
    options?: {
      parseFormat?: string
      offset?: boolean
      format?: 'withYear' | 'withoutYear' | 'withGMT' | 'withoutTime' | 'noticeDate'
    }
  ) => {
    const langWithCountry = i18n.language.toLowerCase()
    dayjs.locale(langWithCountry)

    let formatter = customFormats['default']
    if (customFormats[langWithCountry]) {
      formatter = customFormats[langWithCountry]
    }

    let result: Dayjs
    let offset = options?.offset

    if (typeof date === 'number') {
      if (date / 10000000000 < 1) {
        result = dayjs.unix(date)
      } else {
        result = dayjs(date)
      }
    } else {
      result = dayjs(date, options?.parseFormat || 'YYYYMMDDhhmmss')

      if (offset === undefined) {
        offset = true
      }
    }

    if (offset) {
      result = result.add(dayjs().utcOffset(), 'minute')
    }

    if (options?.format) {
      switch (options.format) {
        case 'withYear':
          return result.format(formatter.withYear)
        case 'withGMT':
          return result.format(formatter.withGMT)
        case 'withoutYear':
          return result.format(formatter.withoutYear)
        case 'withoutTime':
          return result.format(formatter.withoutTime)
        case 'noticeDate':
          return result.format(formatter.noticeDate)
      }
    } else {
      if (result.isToday() || result.isYesterday()) {
        return result.calendar()
      } else if (result.year() === dayjs().year()) {
        return result.format(formatter.withoutYear)
      } else {
        return result.format(formatter.withYear)
      }
    }
  }
}
